(function () {
  var sections = new WeakMap();
  var mobileQuery = window.matchMedia('(max-width: 749px)');
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var stickyState = null;
  var pendingRegistrationFocus = null;

  function getInterval(section) {
    var interval = parseInt(section.getAttribute('data-interval'), 10);
    return Number.isNaN(interval) || interval < 3000 ? 5000 : interval;
  }

  function stop(section) {
    var state = sections.get(section);

    if (state && state.timer) {
      window.clearInterval(state.timer);
      state.timer = null;
    }
  }

  function setActive(section, index) {
    var state = sections.get(section);

    if (!state) {
      return;
    }

    state.index = index;

    state.cards.forEach(function (card, cardIndex) {
      var isActive = cardIndex === index;
      card.classList.toggle('is-active', isActive);
      card.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    state.dots.forEach(function (dot, dotIndex) {
      var isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);

      if (isActive) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  function start(section) {
    var state = sections.get(section);

    if (!state || state.cards.length < 2 || state.timer) {
      return;
    }

    state.timer = window.setInterval(function () {
      setActive(section, (state.index + 1) % state.cards.length);
    }, state.interval);
  }

  function disable(section) {
    var state = sections.get(section);

    stop(section);
    section.classList.remove('is-enhanced');

    if (!state) {
      return;
    }

    state.cards.forEach(function (card, index) {
      card.classList.toggle('is-active', index === 0);
      card.removeAttribute('aria-hidden');
    });

    state.dots.forEach(function (dot, index) {
      dot.classList.toggle('is-active', index === 0);

      if (index === 0) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });

    state.index = 0;
  }

  function enable(section) {
    var state = sections.get(section);

    if (!state || state.cards.length < 2) {
      disable(section);
      return;
    }

    section.classList.add('is-enhanced');
    setActive(section, state.index);
    start(section);
  }

  function sync(section) {
    if (mobileQuery.matches && !motionQuery.matches) {
      enable(section);
    } else {
      disable(section);
    }
  }

  function initSection(section) {
    if (!section || sections.has(section)) {
      return;
    }

    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-retail-testimonial-card]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-retail-testimonial-dot]'));

    sections.set(section, {
      cards: cards,
      dots: dots,
      index: 0,
      interval: getInterval(section),
      timer: null
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-index'), 10);

        if (Number.isNaN(index)) {
          return;
        }

        setActive(section, index);
        stop(section);
        start(section);
      });
    });

    section.addEventListener('focusin', function () {
      stop(section);
    });

    section.addEventListener('focusout', function () {
      if (section.classList.contains('is-enhanced')) {
        start(section);
      }
    });

    section.addEventListener('pointerenter', function () {
      stop(section);
    });

    section.addEventListener('pointerleave', function () {
      if (section.classList.contains('is-enhanced')) {
        start(section);
      }
    });

    sync(section);
  }

  function init(root) {
    var scope = root || document;
    var testimonialSections = scope.querySelectorAll('[data-retail-testimonials]');

    testimonialSections.forEach(initSection);
    initStickyRegistration();
  }

  function syncAll() {
    document.querySelectorAll('[data-retail-testimonials]').forEach(sync);
    syncStickyRegistration();
  }

  function clearStickyRegistration() {
    if (!stickyState) {
      return;
    }

    stickyState.registrationObserver.disconnect();
    stickyState.completionObserver.disconnect();
    stickyState.cta.hidden = true;
    document.body.classList.remove('has-sticky-bottom');
    stickyState = null;
  }

  function syncStickyRegistration() {
    if (!stickyState) {
      document.body.classList.remove('has-sticky-bottom');
      return;
    }

    var shouldShow = mobileQuery.matches &&
      stickyState.registrationPassed &&
      !stickyState.registration.hasAttribute('data-complete');

    stickyState.cta.hidden = !shouldShow;
    document.body.classList.toggle('has-sticky-bottom', shouldShow);
  }

  function initStickyRegistration() {
    var cta = document.querySelector('[data-retail-sticky-cta]');
    var registration = document.querySelector('#retail-registration');
    var registrationViewportTarget = registration && registration.querySelector('#flairRegForm');

    if (!cta || !registration || !registrationViewportTarget || typeof window.IntersectionObserver !== 'function') {
      clearStickyRegistration();
      return;
    }

    if (
      stickyState &&
      stickyState.cta === cta &&
      stickyState.registration === registration &&
      stickyState.registrationViewportTarget === registrationViewportTarget
    ) {
      syncStickyRegistration();
      return;
    }

    clearStickyRegistration();

    var state = {
      cta: cta,
      registration: registration,
      registrationViewportTarget: registrationViewportTarget,
      registrationPassed: false,
      registrationObserver: null,
      completionObserver: null
    };

    var registrationObserver = new IntersectionObserver(function (entries) {
      if (stickyState !== state) {
        return;
      }

      var entry = entries[0];
      state.registrationPassed =
        !entry.isIntersecting &&
        entry.boundingClientRect.bottom <= (entry.rootBounds ? entry.rootBounds.top : 0);
      syncStickyRegistration();
    }, {
      threshold: 0,
      rootMargin: '0px'
    });

    var completionObserver = new MutationObserver(function () {
      if (stickyState === state) {
        syncStickyRegistration();
      }
    });

    state.registrationObserver = registrationObserver;
    state.completionObserver = completionObserver;
    stickyState = state;

    registrationObserver.observe(registrationViewportTarget);
    completionObserver.observe(registration, { attributes: true, attributeFilter: ['data-complete'] });
    syncStickyRegistration();
  }

  function isUsableRenderedControl(control) {
    if (!control || control.disabled || control.readOnly) {
      return false;
    }

    if (control.closest('[hidden], [aria-hidden="true"]')) {
      return false;
    }

    var style = window.getComputedStyle(control);
    return style.display !== 'none' && style.visibility !== 'hidden' && control.getClientRects().length > 0;
  }

  function isEmptyControl(control, step) {
    var type = (control.type || '').toLowerCase();

    if (type === 'checkbox') {
      return control.required && !control.checked;
    }

    if (type === 'radio') {
      if (!control.name) {
        return !control.checked;
      }

      var radios = step.querySelectorAll('input[type="radio"]');
      for (var index = 0; index < radios.length; index++) {
        if (radios[index].name === control.name && radios[index].checked) {
          return false;
        }
      }

      return true;
    }

    return String(control.value || '').trim() === '';
  }

  function findVisibleStepFocusTarget(registration) {
    var form = registration.querySelector('#flairRegForm');
    var step = form && form.querySelector('.flair-step:not([hidden])');
    var stepNumber = step ? parseInt(step.getAttribute('data-step'), 10) : 0;

    if (!step || stepNumber < 1 || stepNumber > 4) {
      return null;
    }

    var controls = Array.prototype.slice.call(step.querySelectorAll('input:not([type="hidden"]), textarea, select'));
    var usable = controls.filter(isUsableRenderedControl);

    for (var index = 0; index < usable.length; index++) {
      if (isEmptyControl(usable[index], step)) {
        return usable[index];
      }
    }

    for (var radioIndex = 0; radioIndex < usable.length; radioIndex++) {
      if (usable[radioIndex].type === 'radio' && usable[radioIndex].checked) {
        return usable[radioIndex];
      }
    }

    return usable.length ? usable[0] : null;
  }

  function focusVisibleRegistrationStep(registration) {
    var control = findVisibleStepFocusTarget(registration);

    if (!control || typeof control.focus !== 'function') {
      return;
    }

    try {
      control.focus({ preventScroll: true });
    } catch (error) {
      control.focus();
    }
  }

  function cancelRegistrationFocus() {
    if (pendingRegistrationFocus) {
      pendingRegistrationFocus.cancel();
    }
  }

  function scheduleRegistrationFocus(registration, smooth) {
    cancelRegistrationFocus();

    var controller = new AbortController();
    var request = {
      timer: null,
      cancel: function () {
        controller.abort();
        window.clearTimeout(request.timer);
        if (pendingRegistrationFocus === request) pendingRegistrationFocus = null;
      }
    };

    var finish = function () {
      if (pendingRegistrationFocus !== request) return;
      request.cancel();
      focusVisibleRegistrationStep(registration);
    };

    var cancelIfCurrent = function () {
      if (pendingRegistrationFocus === request) request.cancel();
    };
    pendingRegistrationFocus = request;

    if (!smooth) {
      request.timer = window.setTimeout(finish, 0);
      return;
    }

    if ('onscrollend' in window) {
      window.addEventListener('scrollend', finish, { once: true, signal: controller.signal });
    }

    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(function (eventName) {
      window.addEventListener(eventName, cancelIfCurrent, { capture: true, once: true, signal: controller.signal });
    });
    request.timer = window.setTimeout(finish, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', syncAll);
    motionQuery.addEventListener('change', syncAll);
  } else {
    mobileQuery.addListener(syncAll);
    motionQuery.addListener(syncAll);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('[data-retail-testimonials]');

    if (section) {
      stop(section);
      sections.delete(section);
    }

    if (
      stickyState &&
      (event.target.contains(stickyState.cta) || event.target.contains(stickyState.registration))
    ) {
      clearStickyRegistration();
    }

    cancelRegistrationFocus();
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-retail-registration-scroll]');

    if (!link) {
      return;
    }

    var target = document.querySelector('#retail-registration');

    if (!target) {
      return;
    }

    event.preventDefault();
    var smooth = !motionQuery.matches;
    target.scrollIntoView({
      behavior: smooth ? 'smooth' : 'auto',
      block: 'start'
    });
    scheduleRegistrationFocus(target, smooth);
  });
})();
